export default __webpack_public_path__ + "static/mpv-shot0002-68bd0029c56050aca3bbe5b177319fcb.png";